module.exports = __webpack_public_path__ + "static/Illithid-5fda9814efcb72ba4a3a7b890999472e.jpg";